import styled from "@emotion/styled";
import { Box, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { attrGrpTableStrColumnsObj } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { useEffect, useState } from "react";
import { studioAttrGrpAttrAssocObj } from "../../StudioAttributes/data";
import { DataGrid } from "@mui/x-data-grid";
import { StudioDashboardState } from "context/StudioDashboardContext";
import { studioAttrGroupLinkedTables } from "../../StudioAttributeGroups/data";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import axios from "axios";
import SearchInputFieldWithDebounce from "components/PimDashboard/CommonComponents/SearchInputFieldWithDebounce/SearchInputFieldWithDebounce";

const VisuallyHiddenInput = styled("input")({
	clip: "rect(0 0 0 0)",
	clipPath: "inset(50%)",
	height: 1,
	overflow: "hidden",
	position: "absolute",
	bottom: 0,
	left: 0,
	whiteSpace: "nowrap",
	width: 1,
});
export const TableImgComponent = ({ data, column }) => {
	return (
		<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
			<Box
				component="label"
				width="45px"
				height="55px"
				border={`1px solid ${grey[200]}`}
				display="flex"
				alignItems="center"
				justifyContent="center"
				overflow="hidden"
				position="relative">
				<img src={data?.[column]} style={{ width: "100%", position: "absolute" }} />
			</Box>
		</Box>
	);
};

export const modalProfileFilterCol = {
	name: "Model Profile",
	key: "modal_profile",
	input_type: inputTypes.SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	[selectOptionsKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (opt) => ({ name: opt.modal_profile_id, key: opt.modal_profile_id }),
	},
};
const ModalSection = ({ selectedModal, setSelectedModal, shootDetails, disabled, hideInput = false, height = 200 }) => {
	const { attrGroupsWithAttr, allAttributes } = StudioDashboardState();
	const [modalTableColumns, setModalTableColumns] = useState();
	useEffect(() => {
		let attrs = [];
		Object.keys(attrGroupsWithAttr).forEach((grpId) => {
			if (
				attrGroupsWithAttr[grpId][attrGrpTableStrColumnsObj.linked_table.key] === studioAttrGroupLinkedTables.modal_profile.key
			)
				attrs = attrGroupsWithAttr[grpId][studioAttrGrpAttrAssocObj];
		});
		setModalTableColumns(attrs?.length ? attrs : []);
	}, [attrGroupsWithAttr]);
	const { setSnackBarOpen, setSnackBar, snackBar } = GlobalState();

	const fetchModalProfileBasedOnSearch = async (offset = 0, limit = 20, searchTerm = "") => {
		const query = {
			limit,
			offset,
		};
		if (searchTerm) query["search"] = searchTerm;
		// construct your request logic
		const res = await axios.get(`/api/studio/modal_profiles_by_search`, {
			params: query,
			query: {},
		});

		return res;
	};

	const handleProfileSelect = (newData) => {
		let obj = typeof newData === "function" ? newData({}) : newData;
		setSelectedModal(obj[modalProfileFilterCol.key]);
	};
	return (
		<Box display="flex" flexWrap="wrap" width="100%">
			<Stack height={height} width="100%" spacing={1}>
				<Stack sx={{ display: hideInput ? "none" : "block", maxWidth: 400 }} spacing={1}>
					<Typography variant="h6" width="100%">
						Model Profile
					</Typography>
					<SearchInputFieldWithDebounce
						disableLabel
						column={modalProfileFilterCol}
						data={{ [modalProfileFilterCol.key]: selectedModal }}
						setData={handleProfileSelect}
						fetchData={fetchModalProfileBasedOnSearch}
						selectOptKeyName={selectOptionsKeyName}
						storeValueAs="object"
						disabled={disabled}
					/>
				</Stack>
				{modalTableColumns?.length >= 0 && (
					<DataGrid
						rows={selectedModal ? [selectedModal] : []}
						columns={[
							{
								headerName: "Image",
								field: "img",
								minWidth: 120,
								headerAlign: "center",
								flex: 1,
								renderCell: ({ row }) => {
									return <TableImgComponent data={row} column="url" />;
								},
							},
							...modalTableColumns?.map((colorCol) => {
								return {
									field: colorCol?.key,
									headerName: colorCol?.name?.toUpperCase(),
									minWidth: 130,
									headerAlign: "center",
									align: "center",
									flex: 1,
								};
							}),
							// deleteTableColumn(handleColorDelete),
						]}
						getRowId={(row) => row?.modal_profile_id}
						sx={{
							minHeight: 100,
							maxHeight: 100,
							// width: "95%",
							"& .MuiDataGrid-row": {
								borderBottom: "1px solid lightgray",
								cursor: "pointer",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								// background: grey[300],
								borderRight: "1px solid lightgray",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={60}
						disableRowSelectionOnClick
						pageSizeOptions={[5, 10]}
						hideFooter
						pagination={false}
						disableAutosize
					/>
				)}
			</Stack>
		</Box>
	);
};

export default ModalSection;
